import * as yup from "yup";

import { DailyMessageInput } from "models/DailyMessage";

export const dailyMessageFormValidationSchema: yup.ObjectSchema<Omit<DailyMessageInput, "date" | "id">> = yup.object({
    context: yup
        .string()
        .trim(),

    isPublished: yup
        .boolean()
        .default(false),
});